import React from 'react';
import { LoadingDots } from 'commonsComponents/loadingDots';

export const ButtonContinue = ({
    buttonContinueAction,
    buttonContinueClass,
    buttonContinueDisabled,
    buttonContinueFakeDisabled,
    buttonContinueLoading,
    buttonContinueText,
    buttonContinueType,
    buttonFinalizeAndContinueHidden,
    buttonFinalizeHidden,
    isButtonContinueLoading,
}) => {
    const buttonClass =
        !buttonFinalizeHidden || buttonFinalizeAndContinueHidden
            ? 'hidden'
            : `${buttonContinueClass} ${buttonContinueFakeDisabled ? 'disable-styles' : ''}`;

    if (buttonContinueLoading) {
        const loadingButtonClass = 'form__button form__button-primary form__button-progress-roadmap-navigation';

        return (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a className={loadingButtonClass}>
                <span className="circle circle-1" data-testid="circle-1" />
                <span className="circle circle-2" data-testid="circle-2" />
                <span className="circle circle-3" data-testid="circle-3" />
            </a>
        );
    }

    return (
        <button
            className={buttonClass}
            disabled={buttonContinueDisabled}
            type={buttonContinueType}
            onClick={buttonContinueAction}
        >
            {isButtonContinueLoading ? <LoadingDots inline size="large" color="dark" /> : buttonContinueText}
        </button>
    );
};
